"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var async_1 = __importDefault(require("react-select/async"));
var mobx_react_1 = require("mobx-react");
var ReactSelectAsyncInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { ref: store.selectWrapperRef },
        react_1.default.createElement(async_1.default, { name: store.name, value: store.selectedOption, onChange: store.handleChange, onBlur: store.handleBlur, onInputChange: store.handleInputChange, onMenuOpen: store.handleMenuOpen, onMenuClose: store.handleMenuClose, onFocus: store.handleFocus, loadOptions: store.loadOptions, cacheOptions: false, filterOption: null, isClearable: true, placeholder: "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", loadingMessage: function () { return "検索中です……"; }, noOptionsMessage: function () { return "候補なし"; } })));
});
exports.default = ReactSelectAsyncInput;
